<script>
export default {
  name: "ParagraphCard"
};
</script>

<style lang="sass">

@import ../../common/styles/mixins

.paragraph-card
  box-shadow: 0px 0px 10px 6px rgba(0,0,0,0.1)
  margin: 2rem
  padding: 2rem 3rem
  border-top: 10px solid $color-base
  width: 200px
  height: 150px
  transition: all .2s ease-in-out
  position: relative

  +media(">=975px")
    &:hover
      transform: scale(1.1)

  +media("<975px")
      width: 100%
      margin: 1.5rem 0
      min-height: fit-content

  .title--4
    font-size: 1.1rem
    font-family: Montserrat, sans-serif
    font-weight: 700
    margin-bottom: 2rem

  .subtitle
    color: #9E9E9E
    font-weight: 400
    position: absolute
    font-size: 0.9rem
    top: 2.8rem

  &--red
    border-top: 10px solid $color-base

  &--dark-blue
    border-top: 10px solid #141f59

  &--blue
    border-top: 10px solid #25a3ab

  &--light-blue
    border-top: 10px solid #6293b9
  &--yellow
    border-top: 10px solid #f4a723

  &--gray
    border-top: 10px solid #2d4d59

  &--violet
  border-top: 10px solid #833d8c

  &--mauve
    border-top: 10px solid #8587b4

</style>
